import { memo, ReactElement } from 'react'

import isEqual from 'lodash/isEqual'

import { updatePortfolio } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { PortfolioGroupBy } from 'types'

import { DateField } from '../SharedFields/DateField'

interface Props<RecordType> {
    dataIndex: string[]
    readOnly: boolean
    record: RecordType
}

function PortfolioEndDateField<RecordType extends PortfolioGroupBy>({
    dataIndex = ['portfolio', 'start_date'],
    readOnly = false,
    record,
}: Props<RecordType>): ReactElement {
    const getIsDisabled = (): boolean => {
        return !record.portfolio.user_can_manage
    }

    return (
        <DateField
            disabled={getIsDisabled()}
            fieldName="start_date"
            fieldPath={dataIndex}
            placeholder="Start Date"
            readOnly={readOnly}
            record={record}
            serializeFieldValues={({ start_date }) => {
                return { start_date: start_date?.format('YYYY-MM-DD') }
            }}
            updateRequestApi={updatePortfolio}
            updateRequestData={record.portfolio.id}
            updateRequestSuccessMesg="Successfully updated portfolio start date"
        />
    )
}

export default memo(
    PortfolioEndDateField,
    isEqual
) as typeof PortfolioEndDateField
